import { render, staticRenderFns } from "./AssignDevicesFleet.vue?vue&type=template&id=651f117e"
import script from "./AssignDevicesFleet.vue?vue&type=script&lang=ts"
export * from "./AssignDevicesFleet.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports